<template>
  <div>
    <div class="relative inline-block w-10 mr-2 align-middle select-none">
      <input
        id="toggle"
        v-model="theme"
        type="checkbox"
        name="toggle"
        true-value="dark"
        false-value="light"
        class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-gray-300 border-4 appearance-none cursor-pointer"
        @input="toggleTheme()"
      />
      <label
        for="toggle"
        class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
      ></label>
    </div>
    <label
      for="toggle"
      class="text-md text-gray-700 dark:text-gray-300 cursor-pointer"
    >
      Enable {{ themeOpposite }} mode
    </label>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  computed: {
    theme() {
      return this.$store.getters.getTheme;
    },
    themeOpposite() {
      return this.$store.getters.getTheme === "dark" ? "light" : "dark";
    },
  },
  methods: {
    toggleTheme() {
      this.$store.dispatch("toggleTheme");
    },
  },
})
export default class Home extends Vue {}
</script>

<style lang="scss" scoped>
/* CHECKBOX TOGGLE SWITCH */
/* @apply rules for documentation, these do not work as inline style */
.toggle-checkbox:checked {
  right: 0;
  background-color: #d1d5db;
  border-color: #1e2636;
}
.toggle-checkbox:checked + .toggle-label {
  background-color: #1e2636;
}
</style>
